<!-- <div class="product">
    <div class="easyzoom easyzoom--overlay main-img" [ngClass]="{loading:!loadAvatar}">
        <img lazy-loaded [src]="menu.avatar|absolutePath:'menus'"
            [attr.data-zoom-image]="menu.avatar|absolutePath:'menus'" [hidden]="!loadAvatar" (load)="loadAvatar=true"
            [alt]="menu.title+'  en livraison'" />
    </div>
    <div class="body">
        <h4>{{menu.title}}</h4>
        <div class="price" *ngIf="!menu.offer">
            <span> {{menu.price}} €</span>
        </div>
        <div class="offer" *ngIf="menu.offer">
            <span>
                <img src="assets/images/offer.png" alt="offer" width="52px">
            </span>
        </div>
        <table width="100%">
            <tr>
                <td>
                    <div class="pull-right" *ngIf="menu.dispo">
                        <ng-container *ngIf="menu.validPeriod==1">
                            <button class="add menu btn" (click)="addToBasket()" [disabled]="siteClose">
                                Ajouter
                            </button>
                        </ng-container>
                        <ng-container *ngIf="menu.validPeriod==0">
                            <button class="btn col-xs-12 dispo pull-right" title="Disponibilité" [disabled]="siteClose">
                                <img src="assets/images/icons/clock.png" width="25px" alt="clock">
                                <span *ngIf="menu.menuTime==1">Midi uniquement</span>
                                <span *ngIf="menu.menuTime==3">Soir uniquement</span>
                            </button>
                        </ng-container>
                    </div>
                    <div class="pull-right" *ngIf="!menu.dispo">
                        <div class="col-xs-12 indisponible">
                            <div class="alert alert-danger text-center">
                                <span>{{orderName | lowercase}} non disponible</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div> -->


<div class="card">
    <div class="avatar" [ngStyle]="{'background-image':'url('+(menu.avatar|absolutePath:'menus')+')'}">
    </div>
    <div class="infos">
        <div class="name">
            {{menu.title|uppercase}}
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <div class="price" *ngIf="!menu.offer">
                {{menu.price | number: '1.1-2'}} €
            </div>
            <div class="price" *ngIf="menu.offer">
                Offre
            </div>
            <ng-container *ngIf="menu.dispoday && menu.dispo && menu.validPeriod==1">
                <button class="btn btn-block btn-danger align-items-center d-flex btn-sm mr-2" (click)="addToBasket()"
                    [disabled]="siteClose">
                    <img class="mr-4" width="25px" src="assets/images/addBasket.png" alt="commander">
                    <span>Ajouter</span>
                </button>
            </ng-container>
        </div>
        <ng-container *ngIf="menu.dispoday">
            <ng-container *ngIf="menu.dispo">
                <div class="indisponible" *ngIf="menu.validPeriod==0">
                    <div class="alert alert-danger text-center" *ngIf="menu.menuTime==1">Disponible midi
                        uniquement</div>
                    <div class="alert alert-danger text-center" *ngIf="menu.menuTime==3">Disponible soir
                        uniquement</div>
                </div>
            </ng-container>
            <div *ngIf="!menu.dispo" class="indisponible">
                <div class="alert alert-danger text-center">{{orderName}} NON DISPONIBLE
                </div>
            </div>
        </ng-container>
        <div *ngIf="!menu.dispoday" class="indisponible">
            <div class="alert alert-danger text-center">NON DISPONIBLE AUJOURD'HUI</div>
        </div>
    </div>
</div>